<template>
    <div class="columns">
        <div class="column">
            <Accordion ref="accordion">
                <template v-slot:title>
                    {{ translate("announcer_board.show_options") }}
                </template>
                <template v-slot:content>
                    <label class="label mb-1">{{ translate("announcer_board.select_mats") }}</label>
                    <MatSelectionBar ref="matSelectionBar" :event-id="eventId"> </MatSelectionBar>

                    <div class="is-flex mt-2">
                        <div class="field mr-3">
                            <label class="label">{{ translate("announcer_board.mats_per_page") }}</label>
                            <div class="control">
                                <input type="number" class="input" v-model="matsPerPage" />
                            </div>
                        </div>

                        <div class="field mr-3">
                            <label class="label">{{ translate("announcer_board.limit_of_matches") }}</label>
                            <div class="control">
                                <input type="number" class="input" v-model="fightsLimit" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="buttons mt-3">
                            <button class="button is-success" @click="applyOptions">
                                {{ translate("common.ok") }}
                            </button>
                            <button class="button is-danger" @click="resetOptions">
                                {{ translate("common.cancel") }}
                            </button>
                        </div>
                    </div>
                </template>
            </Accordion>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Accordion from "../Common/Accordion.vue";
    import MatSelectionBar from "../Common/MatSelectionBar.vue";
    import { ref } from "vue";
    import { useAnnouncerBoardStore } from "./announcerBoardStore";
    import toastMixin from "../Common/toastMixin";
    import translatorMixin from "../Common/translatorMixin";
    import { handleError } from "../Common/errorHandler";
    import { ComponentExposed } from "vue-component-type-helpers";

    const { successToast } = toastMixin.methods;
    const { translate } = translatorMixin.methods;

    const store = useAnnouncerBoardStore();

    const eventId = store.eventId;
    const matSelectionBar = ref<ComponentExposed<typeof MatSelectionBar> | null>(null);
    const accordion = ref<ComponentExposed<typeof Accordion> | null>(null);

    const matsPerPage = ref<number>(store.matsPerPage);
    const fightsLimit = ref<number>(store.fightsLimit);

    function applyOptions() {
        store.selectedMatIds = matSelectionBar.value?.getSelectedMats() ?? [];
        store.pageNumber = 0;
        store.matsPerPage = matsPerPage.value;
        store.fightsLimit = fightsLimit.value;
        accordion.value?.toggle();

        return store
            .refreshAllMats()
            .then(() => {
                successToast(translate("announcer_board.options_applied"));
            })
            .catch(handleError);
    }

    function resetOptions() {
        matSelectionBar.value?.selectMats(store.selectedMatIds);
        matsPerPage.value = store.matsPerPage;
        fightsLimit.value = store.fightsLimit;
        accordion.value?.toggle();
    }
</script>

<style scoped></style>
